import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import FilterModal from "../Contract/filterModal";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import axios from "axios";
import Spinner from "../Contract/Spinner";
import Cookies from "js-cookie";
import api from "../chat/api";
import CustomDropdown from "../Contract/CustomDropdown";
import { toast } from "../../utils/appToast";
import PdfViewer from "../chat/PdfViewer";
import FilterTags from "./FilterTags";
import TagOverflowTooltip from "../Tags/TagOverflowTooltip";
import CreateTagModals from "./CreateTagModals";
import useSalesforcePicker from "./useSalesforcePicker";  
import SalesforceFileModal from "./SalesforceFileModal";
import useGoogleDrivePicker from "./useGoogleDrivePicker";
import GoogleDriveFileModal from "./GoogleDriveFileModal";
import useGooglePicker from "./useGooglePicker";
const ContractTable = ({ isMenuOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [token, setToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(false);
  const editRowRef = useRef(null);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
const actionMenuRefs = useRef({});
const { isConnected, connect, disconnect, accessToken } = useGooglePicker();

  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const fileInputRef = useRef(null);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
const[isCustomApplyFieldModal,setIsCustomApplyFiledModal] =useState(false);
const [selectedTab, setSelectedTab] = useState("manage");
const [fieldName, setFieldName] = useState("");
const [fieldPrompt, setFieldPrompt] = useState("");
const [customFields, setCustomFields] = useState([]);
const [loadingAddField, setLoadingAddField] = useState(false);
const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
const [deletingField, setDeletingField] = useState(null);
const isMaxFieldsReached = customFields.length >= 5;
const isFilled = fieldName.trim() && fieldPrompt.trim();
const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
const moreButtonRef = useRef(null);
const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
const [customFieldPopup, setCustomFieldPopup] = useState({
  visible: false,
  value: '',
  contractKey: '',
  contractId: '',
  x: 0,
  y: 0,
});
const safeColor = (hex) => (hex && hex.startsWith('#') ? hex : '#8B55DD');

const tooltipRef = useRef(null);
const [selectedFilterTags, setSelectedFilterTags] = useState([]); // array of tag IDs
const [filterTagObjects, setFilterTagObjects] = useState([]); // array of full tag objects
const filterButtonRef = useRef(null);
const [showTooltip, setShowTooltip] = useState(false);
const popupRef = useRef(null);
const uploadButtonRef = useRef(null);const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
const [isHovered, setIsHovered] = useState(false);
  const tbodyRef = useRef(null);
  const [selectedFilePreview, setSelectedFilePreview] = useState(null);

const baseColumns = 7; // name, party A, party B, date, etc.
const totalColumns = baseColumns + customFields.length;
const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135
const [isTagModalOpen, setIsTagModalOpen] = useState(false);
const [tagModalDocIds, setTagModalDocIds] = useState([]); // supports single or multi
const openTagModalFor = (docIdOrIds) => {
  const ids = Array.isArray(docIdOrIds) ? docIdOrIds : [docIdOrIds];
  setTagModalDocIds(ids);
  setIsTagModalOpen(true);
};

const [isCreatingNew, setIsCreatingNew] = useState(false);
const [selectedField, setSelectedField] = useState('');
const [newFieldName, setNewFieldName] = useState('');
const [newPrompt, setNewPrompt] = useState('');
const [isLoading, setIsLoading] = useState(false);



const contractKeys = selectedContracts; // update as needed

useEffect(() => {
  if (!isCreatingNew) {
    fetch('/api/v1/contract/custom-fields/')
      .then((res) => res.json())
      .then((data) => setCustomFields(Array.isArray(data) ? data : []))
      .catch((err) => {
        setCustomFields([]);  // fallback to empty array
      });
  }
}, [isCreatingNew]);


const handleApplyField = async () => {
  setIsLoading(true);

  const selectedFieldObj = customFields.find(
    (field) => field.field === selectedField
  );

  const payload = isCreatingNew
    ? {
        new_field: {
          field: newFieldName,
          description: newPrompt,
        },
        contract_keys: selectedContractKeys,
      }
    : {
        field_id: selectedFieldObj?.id, // ✅ send ID, not name
        contract_keys: selectedContractKeys,
      };

  if (!isCreatingNew && !payload.field_id) {
    console.error("Invalid field selected.");
    setIsLoading(false);
    return;
  }

  try {
    const res = await api.post("api/v1/contract/apply-field/", payload);
    setIsCustomApplyFiledModal(false);
    await fetchContracts();
    await fetchCustomFields();

    setSelectedContracts([]);
    setSelectedContractKeys([]);
  } catch (err) {
    console.error("Error:", err);
  } finally {
    setIsLoading(false);
  }
};

  function darkenColor(hex, amount = 0.4) {
  if (!hex || !hex.startsWith('#')) return '#333';
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  // darken each channel
  r = Math.floor(r * (1 - amount));
  g = Math.floor(g * (1 - amount));
  b = Math.floor(b * (1 - amount));

  return `rgb(${r}, ${g}, ${b})`;
}
const handleFilterClear = () => {
  setSelectedFilterTags([]);
  setFilterTagObjects([]);
  setIsFilterModalOpen(false);
  setFilterApplied(false); // 👈 ensure default unfiltered state
  fetchContracts(); // ⬅ reload entire table without any filters
};

useEffect(() => {
  if (isConnected && !hasOpenedPickerOnce) {
    // Don't open picker here
    setHasOpenedPickerOnce(true);
  }
}, [isConnected, hasOpenedPickerOnce]);
const handleAddFromDriveClick = () => {
  openPicker(async (docs) => {
    console.log("📄 Files picked:", docs);

    try {
      const files = await Promise.all(
        docs.map(async (doc) => {
          const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (!res.ok) throw new Error("Failed to fetch file from Drive");

          const blob = await res.blob();
          return new File([blob], doc.name, { type: blob.type });
        })
      );

      setFile(files); // 👈 trigger your upload flow
      setIsModalOpen(true); // 👈 open modal
    } catch (err) {
      console.error("Failed to process selected files", err);
      toast.error("Something went wrong while processing selected files.");
    }
  });
};





const handleToggleMore = () => {
  if (isActionMenuOpen === "more") {
    setIsActionMenuOpen(null);
  } else {
    const rect = moreButtonRef.current.getBoundingClientRect();
    setDropdownCoords({
      top: rect.bottom + window.scrollY + 6,  // Add spacing
      left: rect.left + window.scrollX,       // Align horizontally
    });
    setIsActionMenuOpen("more");
  }
};

const isAllChecked =
  selectedContracts.length === contracts.length && contracts.length > 0;

  const navigate = useNavigate();






  useEffect(() => {
      const cookieToken = Cookies.get("access_token");
      if (cookieToken) {
        setToken(cookieToken);
      } else {
        console.error("Access token missing from cookies");
      }
    }, []);

  const toggleModal = () => {
    
    setIsModalOpen((prev) => !prev);
  };
const handleDeleteField = async (fieldId) => {
  try {
    await api.delete(`/api/v1/contract/delete-field/${fieldId}/`);
    await fetchCustomFields(); // refresh after deletion
  } catch (error) {
    console.error("Error deleting field", error);
  } finally {
    setDeletingField(null);
  }
};



  const handleExport = async () => {
    

    if (!selectedContracts || selectedContracts.length === 0) {
      showPopup("Error", "Please select at least one contract to export.");
      return;
    }

    setExportInProgress(true);

    try {
      const response = await api.post(
        "api/v1/contract/export-file/",
        { contract_keys: selectedContractKeys },
        { responseType: "blob" }
      );
      

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "contracts_export.csv");
      document.body.appendChild(link);
      link.click();

      
    } catch (error) {
      if (error.response) {
        const message =
          error.response.data.msg || "Failed to export contracts.";
        showPopup("Error", message);
      } else {
        showPopup("Error", "An unexpected error occurred. Please try again.");
      }
    } finally {
      setExportInProgress(false);
      setSelectedContracts([]);
    setSelectedContractKeys([]);
    }
  };

const fetchCustomFields = async () => {
  try {
    setCustomFieldsLoading(true);
    const res = await api.get("/api/v1/contract/list-field/");
    const data = res.data;

    // Ensure it's an array before setting
    setCustomFields(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error("Error fetching fields", err);
    setCustomFields([]); // fallback
  } finally {
    setCustomFieldsLoading(false);
  }
};


const handleAddField = async () => {
  if (!fieldName.trim() || !fieldPrompt.trim()) return;
  try {
    setLoadingAddField(true);
    await api.post("/api/v1/contract/create-field/", {
      field: fieldName.trim(),
      description: fieldPrompt.trim(),
    });

    setFieldName("");
    setFieldPrompt("");
    await fetchCustomFields();

    // show inline success message near button
    setFieldCreationSuccess(true);
    setTimeout(() => setFieldCreationSuccess(false), 5000);
    setSelectedTab("manage");
    setIsCustomFieldModalOpen(false);
  } catch (error) {
    console.error("Error adding field", error);
  } finally {
    setLoadingAddField(false);
  }
};


  const handleCancel = () => {
    setSelectedContracts([]);

    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);

    setConfirmDeleteVisible(false);
  };
const handleFilterApply = (selectedNames) => {
  setSelectedFilterTags(selectedNames); // still names like ['kunalll', 'helloss']
  setIsFilterModalOpen(false);

  api.get("/api/v1/rfp/documents/filtered", {
    params: { tags: selectedNames.join(",") },
  })
  .then(res => {
    // Check if results are an array and if it's not empty
    const results = Array.isArray(res.data.results) ? res.data.results : [];
    const filteredContracts = results.length > 0 ? results : [];  // Ensure it's always an array

    // Set filterTagObjects (empty array in case of no results)
    setFilterTagObjects(filteredContracts);

    // Update contracts as well
    setContracts(filteredContracts);  // This will update the table
  })
  .catch((err) => {
    console.log(err, "Failed to apply tag filters.");
    // Optionally handle error, like showing a toast or setting default states
  });
};
  const fetchContracts = useCallback(async () => {
    if (!token) return;
    setLoading(true);

    try {
      const response = await api.get("/api/v1/rfp/documents/");

       const { results } = response.data;

    setContracts(results);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const tableBodyRef = useRef(null);

  const scrollToTop = () => {
    if (tableBodyRef.current) {
      tableBodyRef.current.scrollTop = 0;
    }
  };

  const handleSelectAll = () => {
    if (selectedContracts.length === contracts.length) {
      setSelectedContracts([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedContracts(contracts.map((contract) => contract.id));
      setSelectedContractKeys(contracts.map((contract) => contract.key));
    }
  };

  const filteredContracts = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();

    if (!query) return contracts; // If search is empty, return all contracts

    return contracts.filter((contract) => {
      const contractName =
      contract.name?.toLowerCase() || "";
      const ownerName = contract.details?.["Client name"]?.toLowerCase() || "";
      const customerName =
        contract.details?.["Company Name"]?.toLowerCase() || "";

      return (
        contractName.includes(query) ||
        ownerName.includes(query) ||
        customerName.includes(query)
      );
    });
  }, [contracts, searchQuery]);

  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;
const currentContracts = useMemo(() => {
  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;

  // Ensure filteredContracts is always an array before calling .slice()
  const contractsArray = Array.isArray(filteredContracts) ? filteredContracts : [];
  return contractsArray.slice(indexOfFirstContract, indexOfLastContract);
}, [filteredContracts, currentPage, rowsPerPage]);


  const totalPages = useMemo(
    () => Math.ceil(filteredContracts.length / rowsPerPage),
    [filteredContracts, rowsPerPage]
  );
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

const handleRowsPerPageChange = (event) => {
  setRowsPerPage(25); // Ignore dynamic rows per page and fix it to 25
};


  const handleCheckboxChange = (id, key) => {
    if (selectedContracts.includes(id)) {
      setSelectedContracts(
        selectedContracts.filter((contractId) => contractId !== id)
      );
      setSelectedContractKeys(
        selectedContractKeys.filter((contractKey) => contractKey !== key)
      );
    } else {
      setSelectedContracts([...selectedContracts, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };

  useEffect(() => {
    if (token) {
      fetchContracts();
      fetchCustomFields();
    }
  }, [fetchContracts, token]);

  const handleUploadSuccess = () => {
    fetchContracts();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchContracts();
  };

  const handlePageChange = (event) => {
    const newPage = Number(event.target.value);
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0, openUpwards: false });

const toggleActionMenu = (index, event) => {
  const menuHeight = 150; // Approximate height of the action menu
  const rect = event.currentTarget.getBoundingClientRect();
  const bottomSpace = window.innerHeight - rect.bottom;

  const openUpwards = bottomSpace < menuHeight;

  setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
  setActionMenuPosition({
    top: openUpwards ? rect.top - menuHeight : rect.bottom,
    left: rect.left,
    openUpwards,
  });
};

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };

  const handleViewMore = (contractKey,id) => {
    const condition = "table";
    navigate(`/Contract/contract-details/${contractKey}`, {
  state: { id }, // still send `id` in state if needed
});

  };

  const enableEdit = (contract) => {
    if (contract) {
      setIsActionMenuOpen(false);
      setEditContractId(contract.id);
      setEditedContractData({
        ...contract, // Ensure all contract fields are copied
        details: {
          ...contract.details,
              _custom_fields: contract.details?._custom_fields || {},
 // Ensure existing contract details are copied
        },
      });
    } else {
      setEditContractId(null);
      setEditedContractData({});
    }
  };

const handleEditChange = (field, value) => {
  setEditedContractData((prev) => {
    if (field.startsWith("details._custom_fields.")) {
      const key = field.split(".")[2];
      return {
        ...prev,
        details: {
          ...prev.details,
          _custom_fields: {
            ...prev.details?._custom_fields,
            [key]: value,
          },
        },
      };
    } else if (field.startsWith("details.")) {
      const key = field.split(".")[1];
      return {
        ...prev,
        details: {
          ...prev.details,
          [key]: value,
        },
      };
    } else {
      return {
        ...prev,
        [field]: value,
      };
    }
  });
};


const handleClickOutside = (event) => {
  if (
    isActionMenuOpen !== null &&
    actionMenuRefs.current[isActionMenuOpen] &&
    !actionMenuRefs.current[isActionMenuOpen].contains(event.target)
  ) {
    setIsActionMenuOpen(null);
  }

  if (
    confirmDeleteVisible &&
    event.target.closest(".popup-overlay") === null &&
    !event.target.closest(".popup-box-delete")
  ) {
    setConfirmDeleteVisible(false);
  }
};




  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [confirmDeleteVisible, isActionMenuOpen]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
  };
  const handleDelete = (contractId) => {
    
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
   

    if (!selectedContracts || selectedContracts.length === 0) {
      showPopup("Error", "Please select at least one contract to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

  const handleEditSave = async (contractId) => {
    
  
    try {
      const payload = {
        edited_data: {
    "Client name": editedContractData.details?.["Client name"],
    "Company Name": editedContractData.details?.["Company Name"],
    "Effective Date": editedContractData.details?.["Effective Date"],
    "Renewal Date": editedContractData.details?.["Renewal Date"], // ✅ ADD THIS
    "Expiration Date": editedContractData.details?.["Expiration Date"],
    _custom_fields: editedContractData.details?._custom_fields || {},
  },
        note: editedContractData.note || "",
        name: editedContractData.name || "",
        contract_key: editedContractData.key,  // make sure this is present
      };
  
      const response = await api.post(
        `api/v1/contract/edit-contract-details/${editedContractData.key}/`,
        {
          edited_data: {
            "Client name": editedContractData.details?.["Client name"],
            "Company Name": editedContractData.details?.["Company Name"],
            "Effective Date": editedContractData.details?.["Effective Date"],
                  "Renewal Date": editedContractData.details?.["Renewal Date"], // ✅ FIXED

            "Expiration Date": editedContractData.details?.["Expiration Date"],
            _custom_fields: editedContractData.details?._custom_fields || {}, 
          },
          note: editedContractData.note || "",
          contract_name: editedContractData.name || "",
        }
      );
      
      
  
      if (response.status === 200) {
        const updatedContract = response.data;
        setContracts((prevContracts) =>
          prevContracts.map((contract) =>
            contract.id === contractId ? updatedContract : contract
          )
        );
        setEditContractId(null);
       setRenameSuccessRowId(contractId); // Show success message only for that row

setTimeout(() => setRenameSuccessRowId(null), 4000);
        fetchContracts(); // refresh full list if needed
      }
    } catch (error) {
      console.error("Error saving contract:", error);
      showPopup("Error", "Failed to update contract. Please try again.");
    }
  };
  

const confirmDelete = async () => {
  const idsToDelete = isBulkDelete ? selectedContracts : [contractToDelete];

  if (!idsToDelete?.length) return;

  setDeleteInProgress(true);

  try {
    // Prepare the API request payload
    const payload = {
      doc_ids: idsToDelete,
    };

    // Make a single delete request with multiple doc_ids
    const res = await api.delete("/api/v1/rfp/documents/delete/", { data: payload });

    const deletedDocs = res?.data?.deletedDocs || [];
    const failedDocs = res?.data?.failedDocs || [];

    if (deletedDocs.length > 0) {
      setContracts((prev) => prev.filter((c) => !deletedDocs.includes(c.id)));
    }

    if (failedDocs.length > 0) {
      const msg = failedDocs
        .map((f) => `Document ID ${f.id}: ${f.error}`)
        .join("\n");
      showPopup("Deletion Failed", msg);
    }

    // Clear selections after operation
    setSelectedContracts([]);
    setSelectedContractKeys([]);
  } catch (error) {
    console.error("Error deleting documents:", error);
    showPopup("Error", "Failed to delete document(s). Please try again.");
    setSelectedContracts([]);
    setSelectedContractKeys([]);
  } finally {
    setDeleteInProgress(false);
    setConfirmDeleteVisible(false);
    setContractToDelete(null);
    // Optional: refresh to be 100% in sync with backend
    fetchContracts();
  }
};


  useEffect(() => {
    if (editContractId) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editContractId]);

const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const toInputDateValue = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  // Prevent timezone offset issue by manually extracting parts
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // yyyy-MM-dd
};




  const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
  const selectedFiles = Array.from(event.target.files || []);
  if (selectedFiles.length === 0) return;

  setFile(selectedFiles); // ✅ save to state
  setIsModalOpen(true);
};

  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
const {
  isSFDCConnected,
  handleConnectSFDC,
  handleFetchSFDCFiles,
  sfdcFiles,
  isFetchingSFDCFiles,
  showSFDCFileList,
  setShowSFDCFileList,
  handleSelectSFDCFiles,
  verifySFDCConnection,

  // NEW:
  isSFDCUploading,
  sfdcUploadItems,
} = useSalesforcePicker(fetchContracts);


useEffect(() => {
  verifySFDCConnection(); // run once on mount
}, []);


const {
  isDriveConnected,
  pickerLoaded,
  handleConnectDrive,
  openPicker,
  verifyDriveConnection,
} = useGooglePicker(setFile, setIsModalOpen);

useEffect(() => {
  verifyDriveConnection();
}, []);

  return (
    <>
      {loading && <Spinner />}
      <div className="full-container max-w-full overflow-x-hidden" 
>

        <div className="">
<Header name="Your RFP's" icon={""} isMenuOpen={isMenuOpen} />
        </div>

        <div className="contract-table-container relative overflow-x-hidden">
     <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[2px]">
  {/* LEFT: Search & Filter */}
  <div className="flex items-center gap-1 min-w-[300px]" style={{ marginLeft: isMenuOpen ? "206px" : "110px" }}>
    {/* Search */}
    <div
      style={{
        display: 'flex',
        width: '310px',
        height: '40px',
        padding: '8px 20px 8px 26px',
        alignItems: 'center',
        gap: '1px',
        flexShrink: 0,
        borderRadius: '20px',
        border: isSearchFocused
          ? '1px solid rgba(187, 66, 174, 0.36)'
          : '1px solid rgba(0, 0, 0, 0.10)',
        backgroundColor: '#FFF',
        boxShadow: isSearchFocused
          ? '0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)'
          : 'none',
        overflow: 'hidden',
      }}
    >
      <img
        src="/search.svg"
        alt="Search"
        style={{ width: '24px', height: '24px', marginRight: '4px' }}
      />
      <input
        type="text"
        placeholder="Search Documents Here"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={() => setIsSearchFocused(true)}
        onBlur={() => setIsSearchFocused(false)}
        style={{
          fontFamily: 'Outfit, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          border: 'none',
          outline: 'none',
          width: '100%',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          color: '#171717',
        }}
      />
    </div>

<div className="relative inline-flex items-center gap-2 flex-wrap mt-1">
  {/* Filter Button */}
  <button
    ref={filterButtonRef}
    className={`${selectedFilterTags.length ? "filter-applieds" : ""}`}
    onClick={toggleFilterModal}
  >
    <img
      src={selectedFilterTags.length ? "/Filter_CTA.png" : "/filter.svg"}
      alt="Filter Icon"
    />
  </button>

  {/* 🔽 Background Blur Overlay */}
  {isFilterModalOpen && (
    <div className="fixed inset-0 z-[998] bg-black/5 backdrop-blur-[1.5px]" />
  )}

  {/* 🔽 Filter Dropdown */}
  {isFilterModalOpen && (
    <FilterTags
      selectedTags={filterTagObjects}
      onApply={handleFilterApply}
      onClear={handleFilterClear}
      onClose={() => setIsFilterModalOpen(false)}
      anchorRef={filterButtonRef}
    />
  )}

  {/* Selected tags */}
  {/* {filterTagObjects.slice(0, 2).map((tag) => (
    <div
      key={tag.id}
      className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] whitespace-nowrap"
      style={{
        backgroundColor: `${tag.color}1A`,
        border: `2px solid ${tag.color}`,
        color: darkenColor(tag.color),
      }}
    >
      {tag.name}
    </div>
  ))} */}

  {/* "+N" More tags with tooltip */}
  {filterTagObjects.length > 2 && (
    <div
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      ref={tooltipRef}
    >
      <div
        className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] cursor-default"
        style={{
          backgroundColor: "#F4EBFF",
          border: "1px solid #8B55DD",
          color: "#8B55DD",
        }}
      >
        +{filterTagObjects.length - 2}
      </div>

      {showTooltip && (
        <TagOverflowTooltip
          tags={filterTagObjects.slice(2)}
          anchorRef={tooltipRef}
        />
      )}
    </div>
  )}
</div>
  </div>

  {/* RIGHT SIDE ACTIONS */}
  <div className="flex items-center gap-3 flex-wrap justify-end">
    {selectedContracts.length > 0 ? (
      <>
   


       

    
          <button
       onClick={handleBulkDelete}
   
      className="flex items-center justify-center gap-1 px-[14px] py-[8px] rounded-full border border-transparent bg-red-100 hover:bg-red-200 disabled:opacity-60 disabled:cursor-not-allowed transition"
    >
      <img src="/delete-icon-red.svg" alt="Delete" className="w-4 h-4" />
      <span className="text-[rgba(226,25,25,0.76)] font-[Outfit] text-[14px] font-medium leading-none">
        Delete
      </span>
    </button>

    {/* ✅ Cancel Button */}
    <button
      onClick={handleCancel}
      className="flex items-center justify-center gap-1 p-2 rounded-full border border-[rgba(0,0,0,0.10)] bg-[#ECECEC] transition"
    >
      <img
        src="/cancel_icon.svg"
        alt="Cancel Icon"
        className="w-5 h-5 min-w-[20px] min-h-[20px]"
      />
    </button>
      </>
    ) : (
      <>
        {/* <button
          className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
          onClick={() => setIsCustomFieldModalOpen(true)}
        >
          <img src="/custom-field-icons.svg" className="w-5 h-5" />
          <span className="new-custom-butons-design-text">Custom Field</span>
        </button> */}

        {/* Upload Button + Tooltip */}
        <div className="relative">
        <button
          ref={uploadButtonRef}
          className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
          onClick={() => setIsTooltipVisible(!isTooltipVisible)}
          onMouseEnter={() => {
            if (uploadButtonRef.current) {
              const rect = uploadButtonRef.current.getBoundingClientRect();
              setTooltipCoords({
                top: rect.top + window.scrollY + 45,
                left: rect.left + window.scrollX + rect.width - 140,
              });
            }
          }}
        >
          <img src="/upload_icon_white.svg" className="w-5 h-5" />
          <span className="new-custom-butons-design-texts">Upload</span>
        </button>
      
      
   {isTooltipVisible && (
  <div
    className="fixed z-[9999] w-[188px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
    style={{
      top: `${tooltipCoords.top + 10}px`,
      left: `${tooltipCoords.left - 50}px`,
    }}
    onMouseLeave={() => setIsTooltipVisible(false)}
  >
    {/* Upload from Device */}
    <div
      className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
      onClick={() => {
        setIsTooltipVisible(false);
        fileInputRef.current.click();
      }}
    >
      <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
      Add from device
    </div>
{!isDriveConnected ? (
  <div
    className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
    onClick={handleConnectDrive}
  >
    <img src="/connect-icon.svg" alt="Connect Drive" className="w-4 h-4" />
    Connect Drive
  </div>
) : (
  <div
    className={`flex items-center gap-2 px-3 py-1.5 rounded-[9px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all ${
      !pickerLoaded ? "opacity-60 pointer-events-none" : ""
    }`}
    onClick={openPicker}
  >
    <img src="/picker-icon.svg" alt="Picker" className="w-4 h-4" />
    Add From Drive
  </div>
)}





 {/* Connect Salesforce (SFDC) */}
{isSFDCConnected ? (
  <button onClick={handleFetchSFDCFiles} className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all">    <img src="/salesforce.png" alt="Picker" className="w-4 h-4" />
Add from SFDC</button>
) : (
  <button onClick={handleConnectSFDC} className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all">    <img src="/salesforce.png" alt="Connect Drive" className="w-4 h-4" />
Connect SFDC</button>
)}


  </div>
)}



          <input
            ref={fileInputRef}
            type="file"
            multiple
            className="hidden"
            accept=".pdf,.jpeg,.jpg,.png,.csv,.xlsx,.xls,.docx,.doc"
            onChange={handleFileChange}
          />
        </div>
      </>
    )}
  </div>
</div>

       <div
        className={`overflow-x-auto  transition-all duration-300 mt-2 w-full`}
        style={{
          marginLeft: isMenuOpen ? "182px" : "80px"
        }}
      >
    <div className="overflow-x-auto w-[100%]">
      
      <div className="relative overflow-x-auto  custom-scrollbar-container"  style={{
      height: "calc(100vh - 158px)", // Adjust height as needed
    }}
    ref={tbodyRef}>
<table
  className="text-sm text-left table-auto w-full"
 
>



              <thead className="bg-[#FFF] h-[40px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
                <tr>
                  <th className="w-[40px] px-3">
                   <input
  type="checkbox"
  className="custom-checkbox"
  style={{
    appearance: "none",

    border: "1.5px solid #c0c0c0",
    borderRadius: "4px",
    cursor: "pointer",
    backgroundImage: isAllChecked ? "url('/checck.svg')" : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
  }}
  onChange={handleSelectAll}
  checked={isAllChecked}
/>

                  </th>
           

                     <th className="w-[160px] file-size-of-heading">Document Name</th>
                                     <th className="w-[100px] px-3 file-size-of-heading">Tags</th>
                                     <th className="w-[100px] px-3 file-size-of-heading">Deadline</th>

                  <th className="w-[100px] px-3 file-size-of-heading">Chat</th>
                  <th className="w-[100px] px-3 file-size-of-heading">Upload Date</th>                
                  <th className="w-[180px] px-3 file-size-of-heading">Actions</th>
                </tr>
              </thead>
                <tbody
                  className={
                    currentContracts.length > rowsPerPage ? "scrollable" : ""
                    
                  }
                  style={{
                    overflowY:
                      currentContracts.length > rowsPerPage ? "auto" : "hidden",
                    maxHeight: "400px",
    backgroundColor: "#FFF",
                    
                  }}
                >
                {loading ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      <Spinner />
                    </td>
                  </tr>
                ) : contracts.length > 0 ? (
                  currentContracts.map((contract, index) => (
                    <tr
                      key={index}
                      ref={editContractId === contract.id ? editRowRef : null}
                      style={{
                        background:
                          hoveredRow === index ? "#F8F3FF" : "transparent",
                        boxShadow:
                          hoveredRow === index
                            ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
                            : "none",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                                            className="h-[36px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"

                    >
                      <td className="px-3">
                       <input
  type="checkbox"
  className="custom-checkbox"
  style={{
    appearance: "none",
    // width: "16px",
    // height: "16px",
    border: "1.5px solid #c0c0c0",
    borderRadius: "4px",
    cursor: "pointer",
    backgroundImage: selectedContracts.includes(contract.id)
      ? "url('/checck.svg')"
      : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
  }}
  checked={selectedContracts.includes(contract.id)}
  onChange={() =>
    handleCheckboxChange(contract.id, contract.key)
  }
/>

                      </td>

                      {editContractId === contract.id ? (
                        <>
                          <td className="file-size-of-subheading">
                            <input
                              type="text"
                              value={editedContractData.name || ""}
                              onChange={(e) => handleEditChange("name", e.target.value)}
                              className="edit-contract-custom-two"
                              style={{ color: "#B793ED" }}
                            />
                          </td>
                          <td className="file-size-of-subheading">
                            <input
                              type="text"
                              value={
                                editedContractData.details?.["Client name"] ||
                                ""
                              }
                              onChange={(e) =>
                                handleEditChange(
                                  "details.Client name",
                                  e.target.value
                                )
                              }
                              className="edit-contract-custom-one"
                            />
                          </td>

                          <td className="file-size-of-subheading">
                            <input
                              type="text"
                              value={
                                editedContractData.details?.["Company Name"] ??
                                contract.details?.["Company Name"] ??
                                ""
                              }
                              onChange={(e) =>
                                handleEditChange(
                                  "details.Company Name",
                                  e.target.value
                                )
                              }
                              className="edit-contract-custom-one"
                            />
                          </td>
                          <td className="file-size-of-subheading">
                           <input
  type="date"
  value={
    editedContractData.details?.["Effective Date"]
      ? toInputDateValue(editedContractData.details?.["Effective Date"])
      : ""
  }
  onChange={(e) =>
    handleEditChange("details.Effective Date", e.target.value)
  }
  className="edit-contract"
/>

                          </td>

                          {customFields.map((fieldObj, index) => {
  const fieldKey = fieldObj.field;
  return (
    <td key={index} className="file-size-of-subheading">
      <input
        type="text"
        value={
          editedContractData.details?._custom_fields?.[fieldKey] || ""
        }
        onChange={(e) =>
          handleEditChange(
            `details._custom_fields.${fieldKey}`,
            e.target.value
          )
        }
        className="edit-contract"
      />
    </td>
  );
})}

                          
                          <td className="file-size-of-subheading">
  <input
    type="date"
    value={
      editedContractData.details?.["Renewal Date"]
        ? toInputDateValue(editedContractData.details?.["Renewal Date"])
        : ""
    }
    onChange={(e) =>
      handleEditChange("details.Renewal Date", e.target.value)
    }
    className="edit-contract"
  />
</td>



                          <td className="file-size-of-subheading">
                           <input
  type="date"
  value={
    editedContractData.details?.["Expiration Date"]
      ? toInputDateValue(editedContractData.details?.["Expiration Date"])
      : ""
  }
  onChange={(e) =>
    handleEditChange("details.Expiration Date", e.target.value)
  }
  className="edit-contract"
/>

                          </td>
                          <td className="action-icons-contract">
                            <button
                              onClick={() => handleEditSave(contract.id)}
                              className="icon-button-contract"
                            >
                              <img
                                src="/save-icon-contracttable.svg"
                                alt="Save"
                                className="action-icon"
                              />
                            </button>
                            <button
                              onClick={() => setEditContractId(null)}
                              className="icon-button-contract"
                            >
                              <img
                                src="/cancel-icon-contracttable.svg"
                                alt="Cancel"
                                className="action-icon"
                              />
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
                  <td className="px-0 file-size-of-subheading">
          {contract.name || "N/A"}
        </td> 
      <td className="px-3 file-size-of-subheading">
  {Array.isArray(contract.tags) && contract.tags.length > 0 ? (
    <div
      className="flex flex-wrap gap-1 relative max-w-[190px] group"
      onClick={(e) => {
        e.stopPropagation();
        openTagModalFor(contract.id); // open edit/add tag modal
      }}
    >
      {/* Show up to two tag pills */}
      {contract.tags.slice(0, 2).map((tag) => {
        const c = safeColor(tag.color);
        return (
          <span
            key={tag.id}
            className="tag-pill cursor-pointer"
            style={{
              color: darkenColor(c),
              backgroundColor: `${c}1A`,
              border: `2px solid ${c}`,
            }}
            title={tag.name}
          >
            {tag.name}
          </span>
        );
      })}

      {/* +N more */}
      {contract.tags.length > 2 && (
        <span
          className="tag-pill cursor-pointer"
          style={{
            color: "#8B55DD",
            backgroundColor: "#F4EBFF",
            border: "2px solid #8B55DD",
          }}
          title={contract.tags.slice(2).map((t) => t.name).join(", ")}
        >
          +{contract.tags.length - 2}
        </span>
      )}

      {/* Hover: show all tags */}
      <div className="hidden group-hover:flex absolute top-[100%] left-0 mt-1 z-50 bg-white p-2 rounded-md shadow-lg border border-gray-200 flex-wrap gap-1 w-max max-w-xs">
        {contract.tags.map((tag) => {
          const c = safeColor(tag.color);
          return (
            <span
              key={`full-${tag.id}`}
              className="tag-pill"
              style={{
                color: darkenColor(c),
                backgroundColor: `${c}1A`,
                border: `2px solid ${c}`,
              }}
            >
              {tag.name}
            </span>
          );
        })}
      </div>
    </div>
  ) : (
    <span
      className="inline-flex items-center gap-2 px-3 py-[6px] rounded-[20px] border border-[rgba(0,0,0,0.10)] bg-white text-[#52525B] text-[14px] font-[500] font-[Outfit] cursor-pointer hover:bg-[#F8F3FF]"
      onClick={(e) => {
        e.stopPropagation();
        openTagModalFor(contract.id); // open on empty state
      }}
    >
      + Add Tag
    </span>
  )}
</td>
       <td className="px-0 file-size-of-subheading">
          {contract.deadline_status || "N/A"}
        </td> 
<td>
  <button
    onClick={(e) => {
      e.stopPropagation();
      {{console.log("Navigating to chat with contract key:", contract.key)}}
      navigate("/Rfp/Rfp_chat", {
        state: {
          contractKey: contract.key,
          invoiceUrl: contract.file_url,
        },
      });
    }}
    className="
      group flex items-center justify-center gap-[6px] 
      px-4 py-[6px] 
      rounded-md border border-[rgba(0,0,0,0.10)] 
      text-[#3F3F46] font-medium text-[14px] font-['Outfit']
      transition-colors duration-200
      hover:border-[#8B55DD] hover:bg-[#8B55DD] hover:text-[#F5F4F3]
    "
  >
    {/* Default icon */}
    <img
      src="/chat-icon-docs.svg"
      className="w-4 h-4 block group-hover:hidden"
      alt="Chat"
    />
    {/* Hover icon */}
    <img
      src="/chat-icon-doc-hover.svg"
      className="w-4 h-4 hidden group-hover:block"
      alt="Chat"
    />
    Chat
  </button>
</td>

        {/* Upload Date */}
        <td className="px-3 file-size-of-subheading">
          {formatDate(contract.uploaded_at)}
        </td>







<td className="px-3 file-size-of-subheading">
  <img
    src="./action.svg"
    alt="Actions"
    width="20"
    height="20"
    onClick={(e) => toggleActionMenu(index, e)}
    style={{ cursor: "pointer" }}
  />
  {isActionMenuOpen === index && !selectedFilePreview && (  
    <div
      className="action-menu"
      style={{
        position: 'fixed',
        top: actionMenuPosition.openUpwards ? `${actionMenuPosition.top}px` : `${actionMenuPosition.top}px`,
        left: `${actionMenuPosition.left - 215}px`,
        transform: actionMenuPosition.openUpwards ? 'translateY(50%)' : 'none',
        zIndex: 9999,
      }}
      ref={(el) => {
        if (el) actionMenuRefs.current[index] = el;
      }}
    >
      {/* Eye Icon for Preview */}
      <div
        className="action-item"
        onMouseEnter={() => setHoveredAction("preview")}
        onMouseLeave={() => setHoveredAction(null)}
        onMouseDown={() => setClickedAction("preview")}
        onMouseUp={() => setClickedAction(null)}
        onClick={() => {
          setSelectedFilePreview({ 
            pdf_url: contract.file_url,  // Example URL for preview (replace with actual file URL)
            file_type: contract.file_type, 
            name: contract.name 
          });
        }}
        style={{
          color:
            clickedAction === "preview"
              ? "#C95EBE"
              : hoveredAction === "preview"
              ? "#C95EBE"
              : "",
          transition: "color 0.2s ease-in-out",
          borderRadius: "8px",
          background:
            clickedAction === "preview" || hoveredAction === "preview"
              ? "#FAF9F6"
              : "transparent",
        }}
      >
        <img
          src={clickedAction === "preview" ? "./preview-active.svg" : hoveredAction === "preview" ? "./preview-active.svg" : "./active-eye.svg"}
          alt="Preview Icon"
          className="action-icon"
        />
        <p>Preview</p>
      </div>
      {/* Delete Option */}
      <div
        className="action-item"
        onMouseEnter={() => setHoveredAction("delete")}
        onMouseLeave={() => setHoveredAction(null)}
        onMouseDown={() => setClickedAction("delete")}
        onMouseUp={() => setClickedAction(null)}
        onClick={() => handleDelete(contract.id)}
        style={{
          color:
            clickedAction === "delete"
              ? "var(--reeedd, rgba(226, 25, 25, 0.75))"
              : hoveredAction === "delete"
              ? "var(--reeedd, rgba(226, 25, 25, 0.75))"
              : "",
          transition: "color 0.2s ease-in-out",
          borderRadius: "8px",
          background:
            clickedAction === "delete" || hoveredAction === "delete"
              ? "#FAF9F6"
              : "transparent",
        }}
      >
        <img
          src={clickedAction === "delete" ? "./delete-active-contract.svg" : hoveredAction === "delete" ? "./delete-active-contract.svg" : "./delete.svg"}
          alt="Delete Icon"
          className="action-icon"
        />
        <p>Delete</p>
      </div>
    </div>
  )}
</td>






                        </>
                      )}
                    </tr>
                  ))
                
                    ) : (
                  <tr className="h-[44px] text-center">
                    <td colSpan="7" className="py-6 text-black-400">
                      <img
                        src="/no-contracts.svg"
                        alt="No Data"
                        className="mx-auto mb-2"
                      />
                      <p className="text-[16px]">Looks like your table is empty!</p>
                    </td>
                  </tr>
                )}
             
              </tbody>
            </table>
          </div>
            {contracts.length > 0 && (
              <div className="pagination-doc ml-2">
                  <div className="pagination-dropdown">
  <p className="page-selector">{currentPage}</p>
</div>
                <p className="contentDown">of {totalPages} pages</p>
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  style={{
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="decrease.svg"
                    alt="Previous Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  style={{
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="increase.svg"
                    alt="Next Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
              </div>
            )}
             </div>
          </div>
        </div>

        {popupVisible && (
                    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box">
              <h2>{popupTitle}</h2>
              <p>{popupMessage}</p>
              <button onClick={closePopup} className="popup-close-button">
                Close
              </button>
            </div>
          </div>
        )}

                       {confirmDeleteVisible && (
  <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
    <div className="popup-box-delete">
      <h2>Are you sure you want to delete the selected spreadsheet?</h2>
      <p>
        {isBulkDelete
          ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
          :  "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
      </p>
      <div
        style={{
          display: "flex",
          gap: "8px",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
       
        <button
          onClick={() => setConfirmDeleteVisible(false)}
          disabled={deleteInProgress}
          className="document-popup-close-delete"
        >
          Cancel
        </button>
         <button
          onClick={confirmDelete}
          disabled={deleteInProgress}
          className="document-popup-close-button"
        >
          {deleteInProgress ? "Deleting..." : "Delete"}
        </button>
      </div>
    </div>
  </div>
)}
        <UploadModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onUploadSuccess={handleUploadSuccess}
          type={"rfp_analyze"}
          file={file}
        />

      
        {isCustomFieldModalOpen && (
  <div className="custom-modal-overlay-inline show">
    <div className="custom-modal-content-custom active relative">
      <button
        className="close-modal-custom"
        onClick={() => setIsCustomFieldModalOpen(false)}
      >
        ×
      </button>

      <h2 className="custom-modal-title-custom">Custom Fields</h2>
      <p className="custom-modal-subtitle-custom">
        You can only create up to 5 custom fields per document.<br />
        Deleting a field won’t reset the limit.
      </p>

      <div className="custom-modal-tabs-custom">
        <button
          className={`manage-btn-custom ${selectedTab === "manage" ? "active" : ""}`}
          onClick={() => setSelectedTab("manage")}
        >
          {customFieldsLoading ? "Loading..." : `Manage Existing Fields (${customFields.length}/5)`}
        </button>
        <button
          className={`create-btn-custom ${selectedTab === "create" ? "active" : ""}`}
          onClick={() => setSelectedTab("create")}
        >
          Create New Field
        </button>
      </div>

      {selectedTab === "create" && (
        <>
          <label className="field-label-custom">
            Field name <img src="/bulb.svg" alt="Hint" className="label-icon-custom" />
          </label>
          <input
            type="text"
            className="input-field-custom"
            value={fieldName}
            onChange={(e) => setFieldName(e.target.value)}
            placeholder={
              isMaxFieldsReached
                ? "Maximum 5 fields allowed. Please delete one to add new."
                : "Enter your field name here"
            }
            disabled={isMaxFieldsReached}
          />
          <label className="field-label-custom">
            Extraction Prompt <img src="/bulb.svg" alt="Hint" className="label-icon-custom" />
          </label>
          <textarea
            className="textarea-field-custom"
            value={fieldPrompt}
            onChange={(e) => setFieldPrompt(e.target.value)}
            placeholder={
              isMaxFieldsReached
                ? "Cannot enter prompt. Maximum limit reached."
                : "Enter your Extraction Prompts here"
            }
            disabled={isMaxFieldsReached}
          />
          <button
            className={`add-field-btn-custom ${isFilled && !loadingAddField && !isMaxFieldsReached ? "active" : ""}`}
            onClick={handleAddField}
            disabled={loadingAddField || isMaxFieldsReached}
          >
            {loadingAddField ? "Adding..." : "Add Field"}
          </button>
        </>
      )}

      {selectedTab === "manage" && (
        <div>
          <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
            <div className="flex mt-2 gap-[60px]">
              <h2 className="field-name-custom">Field Name</h2>
              <h2 className="field-name-custom">Prompt</h2>
            </div>
            {customFields.length ? (
              customFields.map((field, index) => (
                <div key={index}>
                  <div className="flex items-start gap-[26px] mt-[12px]">
                  <p className="text-[#1A1A1A] text-sm font-medium w-[100px] break-words">
  {field.field}
</p>

                    <p className="text-[#1A1A1A] text-sm w-[139px]">
                      {field.description}
                    </p>
                    <button
  className="button-red-custom-field"
  onClick={() => {
    setDeletingField(field.id);
    handleDeleteField(field.id);
  }}
  disabled={deletingField === field.id}
>
  {deletingField === field.id ? "Deleting" : "Delete"}
  <img src="/delete-icon-red.svg" alt="Delete" />
</button>

                  </div>
                  <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500 ml-2 mt-3">No custom fields available.</p>
            )}
          </div>

          <button
            className="add-field-btn-custom-twos absolute bottom-4 right-4"
            onClick={async () => {
              await fetchContracts(); // refresh table to show new field
              setIsCustomFieldModalOpen(false);
            }}
          >
            Done
          </button>
        </div>
      )}
    </div>
  </div>
)}
{fieldCreationSuccess && (
  <div className="success-popup inline-flex items-center p-4 bg-white border border-gray-200 shadow-sm rounded-md text-sm text-gray-700 fixed z-[100]"
       style={{
         top: "50%",
         left: "50%",
         transform: "translate(-50%, -50%)"
       }}>
    <img src="/green-icon-tick.svg" className="mr-2" alt="Success" />
    Field Created successfully, Select documents to apply this field
  </div>
)}

{isCustomApplyFieldModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
    <div
      className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] pt-[18px] pl-[24px] pr-[24px] pb-[24px]"
      style={{
        boxShadow:
          '130px 189px 64px rgba(0, 0, 0, 0.00), 83px 121px 59px rgba(0, 0, 0, 0.01), 47px 68px 50px rgba(0, 0, 0, 0.05), 21px 30px 37px rgba(0, 0, 0, 0.09), 5px 8px 20px rgba(0, 0, 0, 0.10)',
      }}
    >
      <div className="flex justify-between items-center">
        <h2 className="apply-heading-cutom">
          Apply Custom Field
        </h2>
         <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1">
          {selectedContracts.length} Contracts selected
        </span>
        <span
         onClick={() => setIsCustomApplyFiledModal(false)}
          className="cursor-pointer text-xl"
        >
          ×
        </span>
      </div>

     

      <div className="flex gap-8 mt-[20px] items-start">
  {/* Option 1: Select Existing */}
  <label className="flex items-center gap-2 cursor-pointer">
    <input
      type="radio"
      checked={!isCreatingNew}
      onChange={() => setIsCreatingNew(false)}
      className="accent-[#7F56D9] w-4 h-4"
    />
    <span className="apply-dot-heading">
      Select from Existing Field
    </span>
  </label>

  {/* Option 2: Create New Field + (2/5 used) below it */}
  <label className="flex flex-col cursor-pointer">
    <div className="flex items-center gap-2">
      <input
        type="radio"
        checked={isCreatingNew}
        onChange={() => setIsCreatingNew(true)}
        className="accent-[#7F56D9] w-4 h-4"
      />
      <span className="apply-dot-heading">
        Create New Field
      </span>
    </div>
<span className="text-xs text-[#999] ml-6">({customFields.length}/5 used)</span>
  </label>
</div>


      {isCreatingNew ? (
        <>
          <label className="apply-dot-heading">Field Name</label>
          <input
            className="apply-input-field pl-2 mt-1"
            placeholder="Enter your field name here"
            value={newFieldName}
            onChange={(e) => setNewFieldName(e.target.value)}
          />
          <label className="apply-dot-heading mt-2">Extraction Prompt</label>
          <textarea
            className="apply-input-field-design-here pl-2 pt-1 pr-1 mt-1"
            placeholder="Enter your Extraction Prompts here"
            value={newPrompt}
            onChange={(e) => setNewPrompt(e.target.value)}
          />
        </>
      ) : (
        <>
          <label className="apply-dot-heading">Choose Field</label>
      <CustomDropdown
  selected={selectedField}
  onSelect={setSelectedField}
  options={customFields.map((field) => field.field)}
/>


        </>
      )}

  <div className="absolute bottom-4 right-4 flex justify-end gap-3">
    <button
      className="cancel-apply-button-design"
      onClick={() => setIsCustomApplyFiledModal(false)}
    >
      Cancel
    </button>
    <button
      onClick={handleApplyField}
      className={`apply-apply-button ${
        isLoading ? 'bg-[#D081D9]' : 'bg-[#D081D9] hover:bg-[#C26ED2]'
      }`}
    >
      {isLoading ? (
        <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
      ) : isCreatingNew ? (
        'Create & Apply'
      ) : (
        'Apply Field'
      )}
    </button>
  </div>
    </div>
  </div>
)}
{customFieldPopup.visible && (
  <div
    ref={popupRef}
    className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
    style={{
      top: `${customFieldPopup.y}px`,
      left: `${customFieldPopup.x - 30}px`,
      maxWidth: "300px",
      width: "max-content",
      whiteSpace: "normal",
    }}
    onMouseEnter={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
    }
    onMouseLeave={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
    }
  >
    <p className="text-gray-800 text-sm font-medium break-words">
      {customFieldPopup.value.length > 40
        ? `${customFieldPopup.value.slice(0, 40)}...`
        : customFieldPopup.value}
    </p>
    <button
      onClick={() =>
        handleViewMore(customFieldPopup.contractKey, customFieldPopup.contractId)
      }
      className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
    >
      View More
    </button>
  </div>
)}
{/* File Preview Modal */}
{selectedFilePreview && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
    onClick={() => setSelectedFilePreview(null)}
  >
    <div
      className="bg-white rounded-lg shadow-lg w-[55vw] h-[80vh] overflow-hidden relative"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Full Preview */}
      {selectedFilePreview.file_type === "pdf" ? (
     
          <PdfViewer
                            pdfUrl={selectedFilePreview.pdf_url}

                  
                />
      ) : (
        <PdfViewer
                            pdfUrl={selectedFilePreview.pdf_url}
      
        />
      )}
    </div>
  </div>
)}

<CreateTagModals
  isOpen={isTagModalOpen}
  onClose={() => setIsTagModalOpen(false)}
  documentId={tagModalDocIds}
  onTagUpdate={fetchContracts}     // refresh the table
  onClearSelection={() => {
    setSelectedContracts([]);
    setSelectedContractKeys([]);
  }}
/>
<SalesforceFileModal
  show={showSFDCFileList}
  onClose={() => setShowSFDCFileList(false)}
  sfdcFiles={sfdcFiles}
  onSelect={handleSelectSFDCFiles}
  isFetching={isFetchingSFDCFiles}
/>
{/* 🔄 SFDC Upload Progress Overlay */}
{isSFDCUploading && (
  <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/30 backdrop-blur-[2px]">
    <div
      className="bg-white rounded-xl shadow-lg w-[400px] max-h-[70vh] flex flex-col p-5"
      style={{
        boxShadow:
          "90px 417px 119px rgba(0,0,0,0), 58px 267px 109px rgba(0,0,0,0.01), 33px 150px 92px rgba(0,0,0,0.05), 14px 67px 68px rgba(0,0,0,0.09), 4px 17px 38px rgba(0,0,0,0.10)",
      }}
    >
      <h2 className="text-[16px] font-semibold text-[#1A1A1A] font-[Outfit] mb-1">
        Uploading from Salesforce…
      </h2>
      <p className="text-[13px] text-[#52525B] font-[Outfit] mb-4">
        We’re importing your file{ sfdcUploadItems.length > 1 ? "s" : "" } into DocuSensa RFP.
      </p>

      <div className="overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)] scrollbar-track-transparent"
           style={{
             maxHeight: "200px",
           }}
      >
        {sfdcUploadItems.map((item) => (
          <div
            key={item.id}
            className="mb-4 last:mb-0 border border-[rgba(0,0,0,0.06)] rounded-lg px-3 py-2 bg-[#FFF]"
          >
            {/* Row: name + status icon/text */}
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <div className="text-[14px] font-medium text-[#171717] font-[Outfit] truncate">
                  {item.title}
                </div>
                <div className="text-[12px] text-[#8E8E93] font-[Outfit]">
                  {item.status === "uploading" && `${item.progress ?? 0}% to complete`}
                  {item.status === "completed" && "Uploaded"}
                  {item.status === "error" && "Failed"}
                  {item.status === "failed" && "Failed"}
                </div>
              </div>

              <div className="ml-2 flex-shrink-0">
                {item.status === "completed" ? (
                  <img
                    src="/right-success-upload.svg"
                    alt="Done"
                    className="w-5 h-5"
                  />
                ) : item.status === "error" || item.status === "failed" ? (
                  <img
                    src="/cross-icon.svg"
                    alt="Error"
                    className="w-5 h-5"
                  />
                ) : (
                  <svg
                    className="animate-spin h-5 w-5 text-[#8B55DD]"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    />
                  </svg>
                )}
              </div>
            </div>

            {/* Progress bar */}
            <div className="w-full bg-[rgba(0,0,0,0.06)] h-[6px] rounded-[3px] mt-2 overflow-hidden">
              <div
                className="h-[6px] rounded-[3px] transition-all duration-200"
                style={{
                  width:
                    item.status === "completed"
                      ? "100%"
                      : item.status === "error" || item.status === "failed"
                      ? "100%"
                      : `${item.progress ?? 0}%`,
                  backgroundColor:
                    item.status === "completed"
                      ? "#22C55E" // green
                      : item.status === "error" || item.status === "failed"
                      ? "#DC2626" // red
                      : "#8B55DD", // purple (in-progress)
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 text-[12px] text-[#A1A1AA] font-[Outfit] text-center">
        Do not close this tab while upload is in progress.
      </div>
    </div>
  </div>
)}


      </div>
    </>
  );
};

export default ContractTable;